import React from 'react';
import { ForgeMenu, ForgeButton } from '@tylertech/forge-react';
import { BsThreeDots } from 'react-icons/bs';
import { FaMinus } from 'react-icons/fa';
import { RenderMode } from '../../types';
import { updateConversation } from '../utils/localStorage';
import HeaderGreetingMessage from '../greetingMessages/HeaderGreetingMessage';
var HeaderMenuOptions;
(function (HeaderMenuOptions) {
    HeaderMenuOptions["CLEAR_CHAT"] = "CLEAR_CHAT";
})(HeaderMenuOptions || (HeaderMenuOptions = {}));
const ChatBotHeader = ({ renderMode, updateBotOpenState, deleteAllMessages }) => {
    if (renderMode === RenderMode.FULL_SCREEN) {
        return null;
    }
    const menuOptions = [
        {
            label: 'Clear chat',
            value: HeaderMenuOptions.CLEAR_CHAT,
        },
    ];
    const onHeaderMenuOptionSelect = (event) => {
        if (event.detail.value === HeaderMenuOptions.CLEAR_CHAT) {
            deleteAllMessages();
            updateConversation('[]');
        }
    };
    return (React.createElement("div", { className: "chatbot-header" },
        React.createElement(HeaderGreetingMessage, null),
        React.createElement("div", { className: "chatbot-header-action-buttons forge-popup-host" },
            React.createElement(ForgeMenu, { className: "header-action-menu", persistSelection: false, placement: renderMode === RenderMode.FIXED ? 'left' : 'bottom', options: menuOptions, "on-forge-menu-select": (event) => onHeaderMenuOptionSelect(event), popupClasses: renderMode === RenderMode.FIXED ? 'forge-menu-custom-styling' : undefined },
                React.createElement(ForgeButton, null,
                    React.createElement("button", null,
                        React.createElement(BsThreeDots, null)))),
            renderMode !== RenderMode.FIXED && (React.createElement("div", { className: "collapse-btn" },
                React.createElement(ForgeButton, { className: "collapse-btn", variant: "text", onclick: () => updateBotOpenState(false) },
                    React.createElement("button", { className: "collapse-btn-icon" },
                        React.createElement(FaMinus, null))))))));
};
export default ChatBotHeader;
//# sourceMappingURL=ChatBotHeader.js.map